// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2agok","amount":"Amount_amount__2BE7g","tip":"Amount_tip__mS0WQ","tipHeader":"Amount_tipHeader__2mUqY","tipsWrap":"Amount_tipsWrap__24rt-"};